import { useNavigate } from 'react-router-dom';
import '../css/FieldResult.css';
import { activePhotos } from '../utilities/fieldData';

const imageForField = (field) => {
    const photos = activePhotos(field);
    return photos.length > 0 ? photos[0].url : undefined;
}

function FieldResult({fieldSnapshot, distanceLabel}) {
    const field = fieldSnapshot.data;
    const image = imageForField(field);
    const navigate = useNavigate();

    return (
    <div key={fieldSnapshot.id}>
        <div className="field">
            <button type="button" onClick={e => {
                navigate( `/fields/${fieldSnapshot.id}`)
            }}>
                {image && <img alt={field.group_name} className="field-image" loading="lazy" src={image} onLoad={e => e.target.classList.add('visible')} />}
                {image === undefined && <img alt={field.group_name} className="field-image visible" src="/field-placeholder.jpg" />}
                <div className="field-text-container">
                    <p>{field.group_name}</p>
                    <p className="field-result-address">{field.address?.displayable_address}</p>
                    {distanceLabel ? <span className="field-result-distance">{distanceLabel}</span> : null}
                </div>
            </button>
        </div>
    </div>
    );
}

export default FieldResult;
